document.addEventListener('DOMContentLoaded', function() {
  // Configuration
  const animationDuration = 2000; // Default duration in ms
  const animationEasing = t => 1 - Math.pow(1 - t, 3); // Ease-out cubic

  // Format number with commas and optional decimal places
  const formatNumber = (num, decimalPlaces) => {
    const fixedNum = decimalPlaces > 0 ? num.toFixed(decimalPlaces) : Math.floor(num);
    return fixedNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // Animation function
  const animateCountUp = (element, targetNumber, originalText, decimalPlaces = 0, duration = animationDuration) => {
    let startTime = null;
    let animationFrameId = null;

    // Extract the suffix with original spacing
    const suffix = originalText.replace(/^[\d,.]+/, '');

    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = animationEasing(progress);
      
      const currentValue = easedProgress * targetNumber;
      element.textContent = formatNumber(currentValue, decimalPlaces) + suffix;
      
      if (progress < 1) {
        animationFrameId = requestAnimationFrame(step);
      } else {
        // Ensure final value is exact
        element.textContent = formatNumber(targetNumber, decimalPlaces) + suffix;
      }
    };

    // Start animation with original suffix spacing
    element.textContent = '0' + suffix;
    animationFrameId = requestAnimationFrame(step);

    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  };

  // Set up Intersection Observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const h2Element = entry.target;
        const motionElement = h2Element.querySelector('motion-element');
        
        if (!motionElement) return;
        
        // Get values from data attributes
        const targetNumber = parseFloat(h2Element.dataset.countUp);
        const originalText = motionElement.textContent.trim();
        const decimalPlaces = h2Element.dataset.countUp.split('.')[1]?.length || 0;
        const duration = h2Element.dataset.duration ? parseInt(h2Element.dataset.duration) : animationDuration;

        // Start animation with original text for spacing reference
        animateCountUp(motionElement, targetNumber, originalText, decimalPlaces, duration);
        
        // Stop observing after animation triggers
        observer.unobserve(h2Element);
      }
    });
  }, {
    threshold: 0.5,
    rootMargin: '0px 0px -100px 0px'
  });

  // Find and observe all count-up elements
  const countUpElements = document.querySelectorAll('[data-count-up]');
  countUpElements.forEach(element => {
    observer.observe(element);
  });
});

$(document).ready(function(){
  var slideCount = $('.cst-slider-main-container .slick-slide').length;
  $('.cst-slider-main-container').slick({
    dots: slideCount > 3,             // Show navigation dots
    infinite: true,         // Infinite looping
    speed: 300,             // Transition speed
    slidesToShow: 3,        // Number of slides to show at a time
    slidesToScroll: 1,      // Number of slides to scroll at a time
    autoplay: true,         // Enable autoplay
    autoplaySpeed: 3000,    // Speed of autoplay (in ms)
    arrows: false,          // Disable arrows
    responsive: [
      {
        breakpoint: 767,   // On smaller screens
        settings: {
          slidesToShow: 1,
          dots: true,  // Show only 1 slide on mobile
        }
      }
    ]
  });
});
$(document).ready(function() {
  // Initialize the slick slider only on mobile (below 767px)
  if ($(window).width() <= 767) {
    $('.tabs-are-slider-now').slick({
      dots: true,             // Show navigation dots
      infinite: true,         // Infinite looping
      speed: 300,             // Transition speed
      slidesToShow: 1,        // Number of slides to show at a time
      slidesToScroll: 1,      // Number of slides to scroll at a time
      autoplay: true,         // Enable autoplay
      autoplaySpeed: 3000,    // Speed of autoplay (in ms)
      arrows: false,          // Disable arrows
      adaptiveHeight: true
    });
  }
});

$(document).ready(function(){
  var slideCount = $('.cst-article-product-slider .slick-slide').length;

  $('.cst-article-product-slider').slick({
    dots: slideCount > 4,           // Show navigation dots
    infinite: true,         // Infinite looping
    speed: 300,             // Transition speed
    slidesToShow: 3,        // Number of slides to show at a time
    slidesToScroll: 1,      // Number of slides to scroll at a time
    arrows: true,          // Disable arrows
    prevArrow: '<button type="button" class="swiper-button-prev btn"><svg class="icon icon-slider-prev icon--medium" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.75 16.2505L6.5 10.0005L12.75 3.75049" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',  // Custom previous arrow
    nextArrow: '<button type="button" class="swiper-button-next btn"><svg class="icon icon-slider-prev icon--medium" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 3.74121L13.75 9.99121L7.5 16.2412" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
    responsive: [
      {
        breakpoint: 1279,   // On smaller screens
        settings: {
          slidesToShow: 2,
          dots: true, 
        }
      },
      {
        breakpoint: 767,   // On smaller screens
        settings: {
          slidesToShow: 1,
          dots: true,  // Show only 1 slide on mobile
        }
      }
    ]
  });

  // FAQ accordion
  $(".faq-accordion h3").click(function(){
    $(this).toggleClass("active");
    $(this).next().slideToggle();
  })
});